import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import styled from 'styled-components';
import { useFloating, offset, flip, shift, arrow, autoUpdate, useHover, safePolygon, useFocus, useInteractions, FloatingPortal, FloatingArrow } from '@floating-ui/react';
import { Text } from '../text/text.js';
import { colors } from '../../tokens/colors/colors.js';
import { spacing } from '../../tokens/spacing/spacing.js';

const ARROW_HEIGHT = 7;
const GAP = 5;
function Tooltip({ title, open, enabled = true, arrow: arrow$1 = true, placement, children, root = null, offset: offset$1, flip: flip$1 = true, disableFocusListener, interactive = true, anchorEl, }) {
    const [internalOpen, setInternalOpen] = useState(false);
    const arrowRef = useRef(null);
    const _open = open === undefined ? internalOpen : open;
    const floating = useFloating({
        open: _open,
        elements: {
            reference: anchorEl,
        },
        onOpenChange: (open) => {
            setInternalOpen(open);
        },
        middleware: [
            offset(offset$1 ?? ARROW_HEIGHT + GAP),
            flip$1 && flip(),
            shift(),
            arrow({
                element: arrowRef,
                padding: 10,
            }),
        ],
        placement,
        transform: true,
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(floating.context, {
        delay: { open: 100 },
        enabled: open === undefined,
        move: false,
        handleClose: interactive ? safePolygon() : null,
    });
    const focus = useFocus(floating.context, {
        enabled: !disableFocusListener,
    });
    const interaction = useInteractions([hover, focus]);
    return (jsxs(Fragment, { children: [jsx(ReferenceWrapper, { ...interaction.getReferenceProps(), ref: floating.refs.setReference, tabIndex: disableFocusListener ? -1 : 0, children: children }), _open && title && enabled && (jsx(FloatingPortal, { root: root, children: jsxs(FloatingWrapper, { ...interaction.getFloatingProps(), style: floating.floatingStyles, ref: floating.refs.setFloating, children: [arrow$1 && (jsx(FloatingArrow, { ref: arrowRef, context: floating.context, height: ARROW_HEIGHT, fill: colors.primaryLight, tipRadius: 2 })), jsx(Text, { variant: "bodyS", children: title })] }) }))] }));
}
const ReferenceWrapper = styled.span ``;
const FloatingWrapper = styled.div `
  padding: ${spacing.S};
  background-color: ${colors.primaryLight};
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 1rem;
  max-width: 300px;

  z-index: 1300;
`;

export { Tooltip };
